/*
ssg
用户信息,权限处理
*/
const state = {
    oneimpor: ""
}
const getters = {
    getOne: state => {
        let tempInfo = localStorage.getItem("oneimpor")
        if (tempInfo)
            state.oneimpor = JSON.parse(tempInfo)
        return state.oneimpor
    }
}
const mutations = {
    setOne(state, oneimpor) {
        state.oneimpor = oneimpor
        localStorage.setItem('oneimpor', JSON.stringify(oneimpor))
    }
}
const actions = {
    setOneInfo({ commit }, oneimpor) {
        commit('setOne', { oneimpor })
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}